module.exports = __webpack_public_path__ + "media/spider.1ab81179.mp4";